<style src="./style.scss">
</style>

<script>
  import classNames from "classnames/bind";
  import MaskInput from "svelte-input-mask";

  export let label;
  export let placeholder = "";
  export let value = "";
  export let disabled = false;
  export let expirationDate = "";
  export let securityCode = "";
  export let cardNumber = "";
  export let finalValue = null;
  let isFocused = false;

  function onFocus() {
    isFocused = true;
  }

  function onBlur() {
    isFocused = false;
  }

  const masks = {
    creditCard: {
      placeholder: finalValue
        ? `•••• •••• •••• ${finalValue}`
        : "Número do cartão",
      mask: "0000-0000-0000-0000",
    },
    expirationDate: {
      placeholder: finalValue ? "••/••" : "MM/AA",
      mask: "00/0000",
    },
    cvv: { placeholder: finalValue ? "•••" : "CVV", mask: "000" },
  };

  const handleChange = ({ detail }, field) => {
    value = detail.inputState.unmaskedValue;

    switch (field) {
      case "cardNumber":
        cardNumber = value;

        if (cardNumber.length === 16) {
          document.getElementById("creditcard-expiration-date").focus();
        }
        break;
      case "expirationDate":
        expirationDate = detail.inputState.maskedValue;

        if (expirationDate.length === 7) {
          document.getElementById("creditcard-cvv").focus();
        }
        break;
      case "securityCode":
        securityCode = value;
        break;
      default:
        break;
    }
  };

  const className = classNames("credit-card");
</script>

<div class="{className}">
  <label class="{`${className}__label`}">Cartão de crédito</label>
  <div
    class="{`${className}__container  ${disabled ? 'disabled' : ''}  ${
      isFocused ? 'focused' : ''
    }`}">
    <MaskInput
      placeholder="{masks.creditCard.placeholder}"
      mask="{masks.creditCard.mask}"
      bind:value="{cardNumber}"
      type="tel"
      autocomplete="cc-csc"
      on:focus="{onFocus}"
      on:blur="{onBlur}"
      on:change="{(event) => handleChange(event, 'cardNumber')}"
      {...$$props} />

    <div>
      <MaskInput
        placeholder="{masks.expirationDate.placeholder}"
        mask="{masks.expirationDate.mask}"
        id="creditcard-expiration-date"
        disabled="{disabled}"
        autocomplete="cc-csc"
        on:change="{(event) => handleChange(event, 'expirationDate')}"
        type="tel"
        bind:value="{expirationDate}"
        on:focus="{onFocus}"
        on:blur="{onBlur}"
        {...$$props} />

      <MaskInput
        placeholder="{masks.cvv.placeholder}"
        mask="{masks.cvv.mask}"
        disabled="{disabled}"
        id="creditcard-cvv"
        autocomplete="cc-csc"
        on:change="{(event) => handleChange(event, 'securityCode')}"
        bind:value="{securityCode}"
        type="tel"
        on:focus="{onFocus}"
        on:blur="{onBlur}"
        {...$$props} />
    </div>
  </div>
</div>
